module.exports = __webpack_public_path__ + "img/default-user.88a6d15b.jpg";